// import qs from 'qs'
import request from '@/utils/request'
// api

// 菜单
export function menuList(params) {
  return request({
    url: '/api/menu/list',
    method: 'get',
    params
  })
}

// 产品系列
export function articleList(params) {
  return request({
    url: '/api/article/list',
    method: 'post',
    data: params
  })
}

//文章详情
export function articleDetail(params) {
  return request({
    url: '/api/article/detail',
    method: 'get',
    params
  })
}

//新增留言

export function message(params) {
  return request({
    url: '/api/message',
    method: 'post',
    data: params
  })
}

//基本信息
export function infoList(params) {
  return request({
    url: '/api/info/list',
    method: 'get',
    params
  })
}
